import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FileUploadModule } from 'ng2-file-upload';
import { TableComponent } from 'projects/Shared-Lib/component/table/table.component';
import { TablePagerComponent } from 'projects/Shared-Lib/component/table/table-pager/table-pager.component';
import { ErrorComponent } from './http_status_codes/error/error.component';
import { AppNgbAccordionComponent } from './accordion/ngbAccordion/app-ngbAccordion.component';

@NgModule({
    declarations: [
        TableComponent,
        TablePagerComponent,
        ErrorComponent,
        AppNgbAccordionComponent
    ],
    imports: [
        CommonModule,
        MatTableModule,
        MatCheckboxModule,
        MatSortModule,
        MatCardModule,
        FormsModule,
        NgbModule,
        FileUploadModule,
        NgSelectModule
    ],
    exports: [
        TableComponent,
        TablePagerComponent,
        ErrorComponent,
        AppNgbAccordionComponent
    ]
})
export class SharedLibModuleModule { }
